var R = require('ramda');
var m = require('mithril');
var d3 = require('d3');
var moment = require('moment');
var loaders = require('../../layout/components/loaders');
var Point = require('../../data/models/point');
var c3 = require('../../libs/chart');
var heading = require('../../components/heading');
var edit = require('../../layout/components/edit');
var columnForm = require('../../data/components/columnModal');
var addColumnOnDataset = require('../../equipment/libs/addColumnOnDataset');
var editColumnOnDataset = require('../../equipment/libs/editColumnOnDataset');
var helpModal = require('../../help/helpModal');

var dateFormat = 'MM/DD/YYYY hh:mm A';
var isReallyEmpty = R.either(R.isNil, R.isEmpty);
var isReallyNotEmpty = R.complement(isReallyEmpty);

var elementChart = {};

function chartDatasetPath(ctrl) {
  return Array.isArray(ctrl.element && ctrl.element.path) ? ctrl.element.path.slice() : [];
}

function openAddPointDialog(ctrl, datasetRecord) {
  return columnForm.editDialogue(
    {out: datasetRecord['@rid'], path: datasetRecord.path || chartDatasetPath(ctrl)},
    { submitCallback: ctrl.parentReinitialize }
  );
}

function createDefaultDatasetAndOpenAddPoint(ctrl) {
  if (!ctrl.element || !ctrl.element['@rid'] || ctrl.creatingDataset) {
    return;
  }

  ctrl.creatingDataset = true;
  return loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/dataset',
    method: 'POST',
    body: {
      parent: ctrl.element['@rid'],
      name: 'Default',
      type: 'list'
    }
  })
  .then(function (datasetRecord) {
    datasetRecord.path = chartDatasetPath(ctrl);
    datasetRecord.out_Column = Array.isArray(datasetRecord.out_Column) ? datasetRecord.out_Column : [];
    ctrl.dataset = datasetRecord;
    ctrl.datasets = [{ in: datasetRecord }];
    ctrl.creatingDataset = false;
    openAddPointDialog(ctrl, datasetRecord);
    m.redraw();
  })
  .catch(function (error) {
    ctrl.creatingDataset = false;
    throw error;
  });
}

elementChart.oninit = function (vnode) {
  var ctrl = this;
  ctrl.parentReinitialize = vnode.attrs.parentReinitialize;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.element = vnode.attrs.element;
  ctrl.height = vnode.attrs.height;
  ctrl.width = vnode.attrs.width;

  ctrl.datasets = Array.isArray(ctrl.element && ctrl.element.out_Contains) ? ctrl.element.out_Contains : [];

  ctrl.columns = [];
  var columns = [];
  var hasBarGraph = false;

  ctrl.datasets.forEach(function (outContains) {
    ctrl.dataset = outContains.in;
    if (ctrl.element.path) {
      ctrl.dataset.path = [...ctrl.element.path];
    } else {
      ctrl.dataset.path = [];
    }

    if (!Array.isArray(ctrl.dataset.out_Column)) {
      return
    }

    ctrl.dataset.out_Column.forEach(function (column) {
      if (column.chartType === 'bar') {
        hasBarGraph = true
      }
      ctrl.columns.push(column);
      columns.push(['x', column.name]);
    });
  })

  ctrl.chartData = {
    x: 'x',
    columns: columns
  };

  if (hasBarGraph) {
    ctrl.chartData.labels = {
      format: function (value) {
        return d3.format('.3s')(value);
      },
      size: 20
    }
  }

  var startTime = moment().valueOf();
  Promise.all(ctrl.columns.map(function (column) {
    if (typeof column.in['@rid'] === 'undefined') {
      return {}
    }
    return loaders.requestWithLoader({
      url: '/api/v1/data/' + (column.in['@rid'].slice(1) || column.in['@rid']),
      method: 'GET',
      params: {
        start: startTime,
        span: ctrl.element.chartSpan || 8,
        resample: ctrl.element.chartResample || 'hours'
      },
      background: true,
      loader:'background'
    })
  }))
  .then(function (data) {
    data.map(function (timeseriesData, idx) {
      var ts = timeseriesData.data;
      if (ts && ts.columns) {
        var rows = [];
        ts.values.forEach(function (row) {
          var colRecord = ctrl.columns[idx];
          if (row[1] == null) { return }
          rows.push([row[0], Point.readValue({unit: colRecord.in.unit, destUnit: colRecord.in.destUnit, displayUnit: colRecord.in.displayUnit, value: row[1]}, true)]);
        })
        rows.shift();
        rows.unshift(['x', ctrl.columns[idx].name + ' (' + Point.formatUnit(ctrl.columns[idx].in) + ')']);
        ctrl.options.data = {
          //x: 'x',
          type: ctrl.columns[idx].chartType || 'line',
          rows: rows
        };
        try {
          ctrl.chart.load(ctrl.options.data);
        } catch (e) {
          setTimeout(function () {
            ctrl.chart.load(ctrl.options.data);
          }, 500)
        }
      }
    })
  })
  .then(function () {
    m.redraw();
  })

  ctrl.handleUpdate = function (data) {
    if (!ctrl.requestComplete) {return};
    if (data.rid == ctrl.point['@rid']) {
      if ((Date.now() - data.time) > 600000) {
        ctrl.chart.flow({
          rows: [
            ['x', ctrl.point.name],
            [data.time * 1000, Point.readValue({
              value: data.value,
              unit: ctrl.point.unit,
              destUnit: ctrl.point.destUnit,
              displayUnit: ctrl.point.displayUnit
            }, true)]
          ],
          length: 1
        });
      }
    };
  }

  ctrl.options = {
    data: ctrl.chartData,
    legend: {
      show: false
    },
    size: {
      height: ctrl.height ? ctrl.height : '',
      width: ctrl.width ? ctrl.width : ''
    },
    grid: {
      x: {
        show: true
      }
    },
    point: {
        show: false
    },
    tooltip: {
      show: true
    },
    axis: {
      y: {
        inner: true,
    	  tick: {
          count: 4,
          format: function (tick) {return parseFloat(tick.toFixed(4).replace(/\.?0+$/, ''))}
        },
        max: ctrl.element.yMax ? parseFloat(ctrl.element.yMax) : undefined,
        min: ctrl.element.yMin ? parseFloat(ctrl.element.yMin) : undefined,
        padding: {top:0, bottom:0}
      },
      x: {
        show: false,
        tick: {
          format: function (ts) { 
            var date = moment(Math.floor(ts / 1e3));
            return date.format(dateFormat);
          } 
        }
      }
    },
  }  
}

elementChart.view = function(vnode) {
  var ctrl = this;
  //var chart = (ctrl.columns ? m('div', {config: elementChart.config(ctrl)}) : '');
  function chartSeriesColor (seriesName) {
    return ctrl.chart && ctrl.chart.data && typeof ctrl.chart.data.colors === 'function'
      ? ctrl.chart.data.colors()[seriesName] || ''
      : '';
  }

  function focusChartSeries (seriesName) {
    if (ctrl.chart && typeof ctrl.chart.focus === 'function') {
      ctrl.chart.focus(seriesName);
    }
  }

  function revertChartFocus () {
    if (ctrl.chart && typeof ctrl.chart.revert === 'function') {
      ctrl.chart.revert('');
    }
  }

  function toggleChartSeries (seriesName) {
    if (!ctrl.chart || !ctrl.chart.data || typeof ctrl.chart.data.shown !== 'function') {
      return;
    }
    ctrl.chart.data.shown(seriesName).length == 0 ?
      ctrl.chart.show(seriesName)
    :
      ctrl.chart.hide(seriesName);
  }

  return m('div',{id:'chart' }, /* {config: c3ParentContainerResizeFix(ctrl)},*/ [
    m(heading, {
      label: ctrl.element.name, 
      class: 'f1', 
      element: ctrl.element, 
      parentReinitialize: ctrl.parentReinitialize, 
      dashboardCallback: ctrl.dashboardCallback, 
      datasetRepresentation: vnode.attrs.datasetRepresentation
    }, [
      ctrl.element.helpText ?
        m('i.ion-ios-information-outline.white.f1.ml2', {
          onclick: () => {
            helpModal.editDialogue(ctrl.element.name, undefined, ctrl.element.helpText);
          }
        })
      :
        ''
    ]),
    //chart
    m(c3,{
      options: ctrl.options,
      oncreate: function (vnode) {
        ctrl.chart = vnode.state.chart;
        vnode.attrs = ctrl.options
      }
    }),
    (function(){
      if (!ctrl.dataset && (!edit.vm.editing() || vnode.attrs.datasetRepresentation)) {
        return '';
      }
      if (vnode.attrs.datasetRepresentation) {
        return m('div.flex.flex-wrap', [
          (ctrl.dataset.columns || []).map(function (column, jdx) {
            let findedColumn;
            (ctrl.dataset.out_Column || []).forEach(columnEdgeRecord => {
              if (!findedColumn && columnEdgeRecord.name == column.name) {
                findedColumn = columnEdgeRecord;
                findedColumn.path = [
                  ...ctrl.dataset.path,
                  {
                    name: findedColumn.name || findedColumn['@class'],
                    '@rid': findedColumn['@rid']
                  }
                ];
              }
            })
            var seriesName = findedColumn ? findedColumn.name + ' (' + Point.formatUnit(findedColumn.in) + ')' : '';
            return m('div.w4.flex.justify-center.items-center.ph2.ba.b--dotted.bw1.mh2.mv1', {
              key: `${column.id}_${column.name}`,
              name: column.name,
              paretDatasetRid: ctrl.dataset['@rid'],
              onmouseenter: ()=> {
                if (!findedColumn) return;
                focusChartSeries(seriesName);
              },
              onmouseleave: revertChartFocus,
              onclick: ()=>{
                if(!edit.vm.editing() && findedColumn){
                  toggleChartSeries(seriesName);
                }
              }
            },[
              findedColumn ?
                [
                  m('i.ion-record.mr2',{style: {color: chartSeriesColor(seriesName)}}),
                  m(`div${edit.vm.editing() ? '.blue.pointer' : ''}`, {
                    onclick: edit.vm.editing() ? columnForm.editDialogue.bind(columnForm, findedColumn, {submitCallback: ctrl.parentReinitialize}) : ''
                  }, findedColumn.name)
                ]
              :
                [
                  m(`div.pointer.mr2${edit.vm.editing() ? '.blue' : ''}`,{
                    onclick: edit.vm.editing() ? editColumnOnDataset.bind(null, column, jdx, ctrl.dataset, findedColumn, ctrl) : ''
                  }, column.name),
                  m(`i.ion-plus.blue.pointer${edit.vm.editing() ? '' : '.dn'}`, {
                    onclick: columnForm.editDialogue.bind(columnForm, {out: ctrl.dataset['@rid'], index: column.id, path: [...ctrl.dataset.path, {name: column.name, '@rid': 'NewCol'}]}, {columnName: column.name, delete: true, submitCallback: ctrl.parentReinitialize})
                  })
                ]
            ])
          }),
          (()=>{
            const isColumnLimitNotDefined = ctrl.limitOfColumns ? false : true;
            const columnCountWithinLimit = (ctrl.dataset.columns || []).length + 1 <= ctrl.limitOfColumns;
            if (edit.vm.editing() && isColumnLimitNotDefined) {
              return m('div.flex.justify-center.items-center.ph2.mh2.mv1', [
                  addColumnOnDataset(ctrl)
              ]);
            } else if (edit.vm.editing() && columnCountWithinLimit) {
                return m('div.flex.justify-center.items-center.ph2.mh2.mv1', [
                    addColumnOnDataset(ctrl)
                ]);
            } else {
                return '';
            }
          })()
        ])
      } else {
        var pointLegends = ctrl.columns.map((columnRecord) => {
          columnRecord.hidden = false
          columnRecord.path = ctrl.dataset.path;
          var seriesName = columnRecord.name + ' (' + Point.formatUnit(columnRecord.in) + ')';
          return m('div.w4.flex.justify-center.items-center.ph2.ba.b--dotted.bw1.mh2.mv1',{
              onmouseenter: ()=> {
                focusChartSeries(seriesName);
              },
              onmouseleave: revertChartFocus,
              onclick: ()=>{
                if(!edit.vm.editing()){
                  toggleChartSeries(seriesName);
                }
              }

            },[
              m('i.ion-record',{style: {color: chartSeriesColor(seriesName)}}),
              m('label.f5.ph2.truncate-ns',{
                class: edit.vm.editing() ? 'blue' :'',
                onclick: edit.vm.editing() ? columnForm.editDialogue.bind(columnForm, columnRecord, { delete: true, submitCallback: ctrl.parentReinitialize, dashboardCallback: ctrl.parentReinitialize }) : ''
              }, columnRecord.name)
            ])
        });

        if (edit.vm.editing()) {
          pointLegends.push(
            m('div.tc.mh2.mv1', [
              m('i.icon.icon-right.ion-plus.blue', {
                onclick: ctrl.dataset ?
                  openAddPointDialog.bind(null, ctrl, ctrl.dataset)
                :
                  createDefaultDatasetAndOpenAddPoint.bind(null, ctrl)
              })
            ])
          );
        }

        return m('div.flex.flex-wrap', pointLegends);
      }
    })(),
  ])
};



module.exports = elementChart;
